import { RootState } from './../../app/store';

export const selectClass = (state: RootState) => state.class;
export const selectClassList = (state: RootState) => (state.class.classCollection || []);
export const selectCurrentClass = (state: RootState) => (state.class.classCollection || [])
    .find(({classId}) => classId === state.class.currentClassId) || null;